<template>
    <form>
        <table class="addon-table links-table-list" :class="{'orderDetail': hideOrderId == true}">
            <tr>
                <th @click="sortByColumn('id')">Link ID <span><i class="fas fa-sort"></i></span></th>
                <th v-if="hideOrderId == false" @click="sortByColumn('order_id')">Order ID <span><i class="fas fa-sort"></i></span></th>
                <th>Order By</th>
                <th @click="sortByColumn('product')">DA/DR<span><i class="fas fa-sort"></i></span></th>
                <th>Category</th>
                <th @click="sortByColumn('destination_link')">Destination URL <span><i class="fas fa-sort"></i></span></th>
                <th v-if="brandMention">Brand Name</th>
                <th v-else @click="sortByColumn('anchor_text')">Anchor Text <span><i class="fas fa-sort"></i></span></th>
                <th @click="sortByColumn('live_link')">Live URL <span><i class="fas fa-sort"></i></span></th>
                <th @click="sortByColumn('status')">Status <span><i class="fas fa-sort"></i></span></th>
                <th>Action</th>
            </tr>
            <tr v-for="link in links" :key="link.id" 
            :class="{ pendingReviewBg: link.status == 'Pending Review', 
            'premium-placement': link.missed_opportunities, 
            'enterprise-bg': link.status != 'Pending Review' && link.packageOrder && link.order_type == 'Enterprise', 
            'media-placement-bg': isMediaPlacementLink(link),
            'brand-mention-bg': isBrandMention(link) }">
                <td @click="openOrderSidebar(link.id)">{{ link.id }}</td>
                <td v-if="hideOrderId == false">{{ link.order_id }}</td>
                <td>{{ link.order_by }}</td>
                <!-- <td><span v-if="link.missed_opportunities">DA </span>{{ link.exact_da }}</td> -->
                <td>{{ isMediaPlacementLink(link) ? getMediaDaLabel(link) : (link.product_name || '') }}</td>
                <td>{{ link.primary_category }}</td>
                <td v-b-tooltip.hover.top="link.destination_link"><a @click="redirectURL(link.destination_link)"><span>{{
                    link.destination_link }}</span> <i v-if="link.destination_link !== true
            ? link.destination_link
            : link.destination_link
        " class="fas fa-external-link-alt"></i></a></td>
                <td v-if="!brandMention && isBrandMention(link)" class="brand-mention-anchor">-</td>
                <td v-else v-b-tooltip.hover.top="link.anchor_text"><div>{{ link.anchor_text }}</div></td>
                <td><template v-if="link.live_link !== true
                        ? link.live_link
                        : link.live_link
                    "><a v-b-tooltip.hover.top="link.live_link" @click="redirectURL(link.live_link)"><span>{{ link.live_link }} </span> <i v-if="link.live_link !== true
            ? link.live_link
            : link.live_link
        " class="fas fa-external-link-alt"></i></a></template></td>

                <!-- <td>
                    <a class="btn-success">{{ link.status }}</a>
                </td> -->
                <td>
                      <a
                        class="btn-success" style="backgroundColor: #41b883; color: #fff"
                        v-if="link.status == 'Delivered'"
                        >{{ link.status }}</a
                      >
                      <a
                        class="btn-secondary" style="backgroundColor: #f4516c; color: #fff"
                        v-if="link.status == 'Not Delivered'"
                        >{{ link.status }}</a
                      >
                      <a
                        class="btn-secondary" style="backgroundColor: #ffb822; color: #fff"
                        v-if="link.status == 'Outreaching'"
                        >{{ link.status }}</a
                      >
                      <a
                        class="btn-success" style="backgroundColor: #00b6cb; color: #fff"
                        v-if="link.status == 'In Writing'"
                        >{{ link.status }}</a
                      >
                      <a
                        class="btn-success" style="backgroundColor: #36a3f7; color: #fff"
                        v-if="link.status == 'Pending Review'"
                        >{{ link.status }}</a
                      >
                      <a
                        class="btn-success" style="backgroundColor: #9816f4; color: #fff"
                        v-if="link.status == 'Refund'"
                        >{{ link.status }}</a
                      >
                      <a
                        class="btn-success" style="backgroundColor: #36a3f7; color: #fff"
                        v-if="link.status == 'Link Submission'"
                        >{{ link.status }}</a
                      >
                      <a
                        class="btn-success" style="backgroundColor: red; color: #fff"
                        v-if="link.status == 'Cancel'"
                        >{{ link.status }}</a
                      >
                      <a
                        class="" style="backgroundColor: #FFCCCC; color: #000"
                        v-if="link.status == 'On Hold'"
                        >{{ link.status }}</a
                      >
                      <a
                        class="btn-secondary" style="background-color: #d97706; color: #fff"
                        v-if="link.status == 'Payment Processing'"
                        >{{ link.status }}</a
                      >
                      <a
                        class="btn-secondary" style="background-color: #dc2626; color: #fff"
                        v-if="link.status == 'Payment Failed'"
                        >{{ link.status }}</a
                      >
                    </td>
                <!-- <td>
                    <div class="btn-box">
                        <a href="javascript:;"><i class="fas fa-eye" @click="openOrderSidebar(link.id)"></i></a>
                    </div>
                </td> -->
                <td class="action-btns">
                    <div class="btn-group">
                    <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                        ...
                    </button>

                    <ul class="dropdown-menu" role="menu">
                        <li><a href="javascript:;" @click="openOrderSidebar(link.id)">View</a></li>
                        <li><a href="javascript:;" v-if="link.allowEditLink && !isBrandMention(link)" @click="currentLink(link.id, link.anchor_text, link.destination_link)">Edit</a></li>
                    </ul>

                    </div>
                </td>
            </tr>
        </table>
    </form>

    <b-modal
      id="modal-box-edit-link"
      class="rivision-modal-box"
      v-model="showEditLinkModal"
      centered
      title="Edit Link"
      :no-close-on-backdrop="true"
    >
      <form>
        <b-row>
          <b-col md="12">
            <div class="form-group">
              <label>Anchor Text</label>
              <b-form-input
                id="input-6"
                v-model="editLinkData.text"
                type="text"
                required
              ></b-form-input>
              <span
                v-if="errors.text"
                class="required-text invalid-feedback"
                style="display: block"
                role="alert"
              >
                <strong>{{
                  errors.text[0]
                }}</strong>
              </span>
            </div>
          </b-col>
          <b-col md="12">
            <div class="form-group">
              <label>Destination URL</label>
              <b-form-input
                id="input-6"
                v-model="editLinkData.url"
                type="text"
                required
              ></b-form-input>
              <span
                v-if="errors.url"
                class="required-text invalid-feedback"
                style="display: block"
                role="alert"
              >
                <strong>{{
                  errors.url[0]
                }}</strong>
              </span>
            </div>
          </b-col>
          <b-col md="12">
            <div class="btn-box-list">
              <a href="javascript:;" @click="updateLinlDetails" class="btn-1"
                >Update
              </a>
            </div>
          </b-col>
        </b-row>
      </form>
    </b-modal>

</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
    props: ['links','hideOrderId','brandMention'],
    mounted() {
    },
    
    watch: {
        links() {
            this.linksDetail = this.links;
        },
    },
    data() {
        return {
            showEditLinkModal: false,
            linksDetail: [],
            addClass: '',
            errors: [],
            editLinkData: {
                link_id: '',
                text: '',
                url: ''
            }
        };
    },
    emits: ['openOrderSidebar'],
    methods: {
        openOrderSidebar(value) {
            var arr = this.linksDetail;
            arr = arr.filter(x => x.id === value);
            this.$emit('openOrderSidebar', arr[0])
        },

        redirectURL(url) {
            const pattern = /^(http:\/\/|https:\/\/)/i;
            const hasHttpOrHttps = pattern.test(url);

            let finalUrl = url;
            if (!hasHttpOrHttps) {
                finalUrl = 'https://' + url;
            }

            const newTab = window.open(finalUrl, '_blank');
            if (newTab) {
                newTab.focus();
            }
        },
        sortByColumn(column) {
            this.order = (this.order == 'asc') ? 'desc' : 'asc';
            this.$parent.getSortedResults(column,this.order);
        },
        isBrandMention(link) {
          return link?.order_type === 'brand_mention';
        },
        isMediaPlacementLink(link) {
          return (
            link?.media_placement === true ||
            link?.media_link === true ||
            Number(link?.media_placement_id) > 0
          );
        },
        getMediaDaLabel(link) {
          const value = link?.exact_da ?? link?.exact_da_dr ?? link?.authority;
          return value != null && String(value).trim() !== "" ? `DA ${value}` : "";
        },
        async currentLink(id, text, url) {
            this.editLinkData.link_id = id;
            this.editLinkData.text = text;
            this.editLinkData.url = url;
            this.showEditLinkModal = true; // modal open
        },
        async updateLinlDetails() {
          var destURL = this.editLinkData.url;
          if (!this.isValidURL(destURL.trim().toLowerCase())) {
            this.errors = {
                url: ["URL format is invalid"]
              };  
          }
          else{
            this.$parent.loading = true;
            try {
                const res = await this.$store.dispatch(
                "Product/updateLinkDetailsDataAction",
                this.editLinkData
                );
                if (res.success) {
                    this.$parent.loading = false;
                    toast.success(res.message, { timeout: 3000 });
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                    this.showEditLinkModal = false;
                }
            } catch (e) {
                this.$parent.loading = false;
                this.errors = e.response.data.errors;
            }
          }
        },
        isValidURL(url) {
          var isValid = "";
          var match = url.match(/(?:https:\/\/)?(?:www\.)?(.*?)\./);
          const extractedValue = match ? match[1] : "";
          if (/^w+$/.test(extractedValue) && extractedValue.length > 3) {
            isValid = false;
          } else {
            if (/^w+$/.test(extractedValue) && extractedValue.length == 3) {
              const urlPattern =
                /^(?:(?:(?:https?|ftp):\/\/)?(?:www\.)?)?(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))(?:\/(?:[^\s/]*\/)?)?)?(?:\?(?:\S*))?(?:\.(?![^\s.]*$))?$/i;
              isValid = urlPattern.test(url);
            } else {
              const urlPattern =
                /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:(?!www)[/?#]\S*)?$/;
              isValid = urlPattern.test(url);
            }
          }
          return isValid;
        },
    },
}
</script>

<style>
.track-order-main-sec .editor-dashboard-sec-2 .table-responsive table.links-table-list tr td.brand-mention-anchor {
  text-align: center !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
}
</style>